"use client";

import LandingPageLayout from "@/components/layout/LandingPageLayout";
import FormField from "@/components/text/FormField";
import { contactSupportSchema } from "@/schema";
import { contactSupport } from "@/services/auth.service";
import { _notifyError, _notifySuccess } from "@/utils/alert";
import { yupResolver } from "@hookform/resolvers/yup";
import { CircularProgress } from "@mui/material";
import { Button } from "@nextui-org/react";
import { useMutation } from "@tanstack/react-query";
import { Controller, useForm } from "react-hook-form";

export default function ContactSupport() {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: { email: "", full_name: "", message: "" },
    resolver: yupResolver(contactSupportSchema),
  });

  const { mutate, isPending } = useMutation({
    mutationFn: contactSupport,
    onSuccess: (data) => {
      _notifySuccess(data?.message);
      reset();
    },
    onError: (error) => _notifyError(error?.message),
  });

  return (
    <LandingPageLayout>
      <div className="lg:p-20 lg:pb-0 md:pb-0 pb-0 md:p-12 p-6 space-y-12 flex flex-col items-center">
        <h2 className="text-primary font-semibold md:text-3xl text-2xl">
          Contact Monietab Support
        </h2>
        <form
          onSubmit={handleSubmit(mutate)}
          className="lg:w-[500px] md:w-[400px] w-full"
        >
          <Controller
            name="full_name"
            control={control}
            render={({ fieldState: { error }, field }) => (
              <FormField {...field} error={error} placeholder="Full Name" />
            )}
          />

          <Controller
            name="email"
            control={control}
            render={({ fieldState: { error }, field }) => (
              <FormField
                {...field}
                error={error}
                placeholder="example@gmail.com"
              />
            )}
          />

          <Controller
            name="message"
            control={control}
            render={({ fieldState: { error }, field }) => (
              <FormField
                {...field}
                error={error}
                placeholder="Message"
                type="textarea"
              />
            )}
          />

          <Button
            type="submit"
            className="bg-primary w-full font-bold rounded-[5px] h-12 text-white mb-3 disabled:bg-[grey]"
            disabled={isPending}
          >
            {isPending ? (
              <CircularProgress color="#FFFFFF" size={28} />
            ) : (
              "Send Message"
            )}
          </Button>
        </form>
      </div>
    </LandingPageLayout>
  );
}
